<script>
    import {createEventDispatcher} from 'svelte';

    import Caja from "../../UI/Caja.svelte";
    import {url} from '@sveltech/routify';

    import Boton from "../../UI/Boton.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Icono from "../Icono.svelte";
    import Roles from "../../UI/Roles.svelte";

    export let usuario;

    const dispatch = createEventDispatcher();

    const eliminarUsuario = () => dispatch('eliminar-usuario', usuario);
</script>

<style>
    .acciones {
        text-align: right;
    }

    .titulo {
        display: flex;
        align-items: flex-end;
        align-items: center;
    }

    .horario strong {
        font-weight: 500;
    }
</style>

<div class="tipoDeJornada">
    <Caja>
        <div slot="titulo" class="titulo">
            <Subtitulo>{usuario.nombre}</Subtitulo>
        </div>

        <div class="tipo">
            {usuario.email}
        </div>

        <div slot="pie" class="acciones">
            {#if !usuario.protegido}
                <Boton href={$url(`/usuarios/${usuario.id}`)} icono="edit" tipo="ok">
                    Editar
                </Boton>

                <Boton on:click={eliminarUsuario} icono="delete" tipo="peligro">Borrar</Boton>
            {/if}
        </div>
    </Caja>
</div>